module.exports = __webpack_public_path__ + "images/backgrounds/orange-blur.f95314523b1027fed9e2.png";